
import { EntityUpdateTypes } from "@enums/entity-update-types";
import { EntityUpdateModalOptions } from "@idw-types/entity-update-modal-option";

export const entityStatusUpdateModalOptions: {
    [key in EntityUpdateTypes]: EntityUpdateModalOptions
} = {
    [EntityUpdateTypes.RELYING_PARTY]: {
        key: "relying-party",
        textResourceKey: "RelyingParty",
    },
    [EntityUpdateTypes.ORGANIZATION]: {
        key: "organization",
        textResourceKey: "Organization",
    }
};
